import { render, staticRenderFns } from "./pkgDistributAgentPrice.vue?vue&type=template&id=40169d86&"
import script from "./pkgDistributAgentPrice.vue?vue&type=script&lang=js&"
export * from "./pkgDistributAgentPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports